import { Google, Pixall } from '../analytics/index.js';
import { myWalletClickHelper } from './helpers/index.js';
import { DataLayerTransformer } from '../transformers/pixall/index.js';
import { getInventoryOwnerById } from '../utilities/index.js';
export const formatEvent = function (text, replacement) {
  if (text === void 0) {
    text = '';
  }
  if (replacement === void 0) {
    replacement = '-';
  }
  return text.replace(/& /g, '').replace(/ /g, `${replacement}`).replace(/\./g, '').toLowerCase();
};

/**
 * @summary Sends Google/Pixall event when header nav item clicked
 * @events event1
 */
export async function headerNavItemClick(metadata, option) {
  const {
    data = {},
    dataLayer
  } = metadata;
  const {
    onEventKey = '',
    text = '',
    ...rest
  } = data;
  let eventResult;
  switch (onEventKey) {
    case 'home':
      eventResult = 'homepage::autotrader';
      break;
    case 'lnkFycUsed':
      eventResult = `slp_used::${formatEvent(text)}`;
      break;
    case 'lnkFycNew':
      eventResult = `slp_new::${formatEvent(text)}`;
      break;
    case 'privateSeller':
      eventResult = 'srp::private-seller';
      break;
    case 'lnkSyc':
      eventResult = 'slp_syc::sell-your-car';
      break;
    case 'lnkTim':
      eventResult = `ico::${formatEvent(text)}`;
      break;
    case 'lnkFyd':
      eventResult = `srp_dealer::${formatEvent(text)}`;
      break;
    case 'psxVDP':
      eventResult = 'slp_psx_buy::private-seller-exchange';
      break;
    default:
      break;
  }
  Google.sendClickEvent({
    eventElement: 'global-nav-header',
    eventResult: `text-link::${eventResult}`,
    eventNonInteractive: false
  }, option);
  Pixall.sendClickEvent({
    eventSource: 'application',
    eventType: 'click',
    feature: 'global-nav-header',
    label: `text-link::${eventResult}`,
    pageId: DataLayerTransformer.getPageId(dataLayer),
    pageType: dataLayer?.page?.pageType,
    fullURL: window.location.href,
    hasListingType: false
  });
  return rest;
}

/**
 * @summary Sends Google/Pixall event when car research header links clicked
 * @events event1
 */
export async function headerCarResearchLinksClick(metadata, option) {
  const {
    data = {},
    dataLayer
  } = metadata;
  const {
    text = '',
    destination = '',
    ...rest
  } = data;
  Google.sendClickEvent({
    eventElement: 'global-nav-header',
    eventResult: `text-link::article_results_${formatEvent(destination)}::${formatEvent(text)}`,
    eventNonInteractive: false
  }, option);
  Pixall.sendClickEvent({
    eventSource: 'application',
    eventType: 'click',
    feature: 'global-nav-header',
    label: `text-link::article_results_${formatEvent(destination)}::${formatEvent(text)}`,
    pageId: DataLayerTransformer.getPageId(dataLayer),
    pageType: dataLayer?.page?.pageType,
    hasListingType: false
  });
  return rest;
}

/**
 * @summary Sends Google/Pixall event when ico link clicked
 * @events event1
 */
export async function headerICOClick(data, option, isPrivateSeller, dataLayer) {
  const {
    onEventKey = '',
    link,
    ...rest
  } = data;
  const element = onEventKey === 'lnkKbbIM' ? 'homepage' : 'global-nav-header';
  const originatedLocation = isPrivateSeller ? 'private-seller' : element;
  Google.sendClickEvent({
    eventElement: 'global-nav-header',
    eventResult: `tile::${originatedLocation}::${formatEvent(link.label)}`,
    eventNonInteractive: false
  }, option);
  Pixall.sendClickEvent({
    eventSource: 'application',
    eventType: 'click',
    feature: 'global-nav-header',
    label: `tile::${originatedLocation}::${formatEvent(link.label)}`,
    pageId: DataLayerTransformer.getPageId(dataLayer),
    pageType: dataLayer?.page?.pageType,
    fullURL: window.location.href,
    hasListingType: false
  });
  return rest;
}

/**
 * @summary Sends Google/Pixall event when header partner tile clicked
 * @events event1
 */
export async function headerPartnersTileClick(metadata, option) {
  const {
    data = {},
    dataLayer,
    state
  } = metadata;
  const {
    onEventKey = '',
    partnerType = '',
    partner = '',
    sponsoredText = '',
    link,
    inventoryId,
    ...rest
  } = data;
  const inventory = getInventoryOwnerById(state, inventoryId);
  const pageId = DataLayerTransformer.getPageId(dataLayer);
  const isPrivateSeller = inventory?.owner?.privateSeller;
  if (['lnkKbbTim', 'lnkKbbIM'].indexOf(onEventKey) > -1) {
    headerICOClick(data, option, isPrivateSeller, dataLayer);
  } else {
    Google.sendClickEvent({
      eventElement: 'global-nav-header',
      eventResult: `${partnerType}::${partner}::${formatEvent(sponsoredText)}::${formatEvent(link.label)}::module`,
      eventNonInteractive: false,
      vehicle: {
        cj_ga_event_value_code: 'D52F' // CD166
      }
    }, option);
    Pixall.sendClickEvent({
      feature: 'global-nav-header',
      eventSource: 'application',
      eventType: 'click',
      fullURL: window.location.href,
      label: 'prequal_car_loan',
      pageType: pageId === 'calc_pymt' || pageId === 'calc_afd' || pageId === 'calc_lse_loan' ? 'financial' : 'search',
      vendor: data?.name,
      hasListingType: false,
      ...(isPrivateSeller && {
        pageId: 'fyc_psx_vdp'
      })
    }, dataLayer, option);
  }
  return rest;
}

// /**
//  * @summary Sends Google/Pixall event when header partner CTA clicked
//  * @events event1
//  */
export async function headerPartnersCTAClick(metadata, option) {
  const {
    data = {},
    dataLayer,
    state
  } = metadata;
  const {
    onEventKey = '',
    partnerType = '',
    partner = '',
    sponsoredText = '',
    link,
    inventoryId,
    ...rest
  } = data;
  const pageId = DataLayerTransformer.getPageId(dataLayer);
  const inventory = getInventoryOwnerById(state, inventoryId);
  const isPrivateSeller = inventory?.owner?.privateSeller;
  if (['lnkKbbTim', 'lnkKbbIM'].indexOf(onEventKey) > -1) {
    headerICOClick(data, option, isPrivateSeller, dataLayer);
  } else {
    Google.sendClickEvent({
      eventElement: 'global-nav-header',
      eventResult: `${partnerType}::${partner}::${formatEvent(sponsoredText)}::${formatEvent(link.label)}::module`,
      eventNonInteractive: false,
      vehicle: {
        cj_ga_event_value_code: 'D52F' // CD166
      }
    }, option);
    Pixall.sendClickEvent({
      feature: 'global-nav-header',
      eventSource: 'application',
      eventType: 'click',
      fullURL: window.location.href,
      label: 'prequal_car_loan',
      pageType: pageId === 'calc_pymt' || pageId === 'calc_afd' || pageId === 'calc_lse_loan' ? 'financial' : 'search',
      vendor: data?.name,
      hasListingType: false,
      ...(isPrivateSeller && {
        pageId: 'fyc_psx_vdp'
      })
    }, dataLayer, option);
  }
  return rest;
}

/**
 * @summary Sends Google/Pixall event when car research header links shows
 * @events event1
 */
export async function headerPartnersImpression(metadata, option) {
  const {
    data = {},
    dataLayer,
    state
  } = metadata;
  const {
    partnerType = '',
    partner = '',
    sponsoredText = '',
    link,
    originatedLocation = 'homepage',
    inventoryId,
    ...rest
  } = data;
  const pageId = DataLayerTransformer.getPageId(dataLayer);
  const inventory = getInventoryOwnerById(state, inventoryId);
  const isPrivateSeller = inventory?.owner?.privateSeller;
  Google.sendImpressions(metadata, {
    eventElement: 'global-nav-header',
    eventResult: `${partnerType}::${partner}::${formatEvent(sponsoredText)}::${formatEvent(link.label)}::${originatedLocation}`,
    eventNonInteractive: false
  }, option);
  const pageTypePixall = () => {
    let pageType;
    switch (pageId) {
      case 'calc_pymt':
      case 'calc_afd':
      case 'calc_lse_loan':
        pageType = 'financial';
        break;
      default:
        pageType = dataLayer?.page?.pageType;
        break;
    }
    if (isPrivateSeller) {
      pageType = 'vdp';
    }
    return pageType;
  };
  Pixall.sendImpression({
    dataLayer
  }, {
    feature: 'global-nav-header',
    eventSource: 'application',
    eventType: 'impression',
    label: 'prequal_car_loan',
    pageType: pageTypePixall(),
    pageId: isPrivateSeller ? 'fyc_psx_vdp' : DataLayerTransformer.getPageId(dataLayer),
    vendor: data?.name,
    hasListingType: false,
    fullURL: window.location.href,
    applicationType: 'loan'
  }, option);
  return rest;
}

/**
 * @summary Sends Google/Pixall event when links within myatc dropdown clicked
 * @events event1
 */
export async function headerSellYourCarLinksClick(metadata, option) {
  const {
    data = {},
    dataLayer,
    state
  } = metadata;
  const {
    label,
    destinationPage,
    inventoryId,
    ...rest
  } = data;
  const inventory = getInventoryOwnerById(state, inventoryId);
  const isPrivateSeller = inventory?.owner?.privateSeller;
  const isLoggedIn = dataLayer?.user?.isLoggedIn !== 0 && dataLayer.user?.isLoggedIn !== '0';
  const destinationLabel = isLoggedIn ? formatEvent(destinationPage) : 'my-sign-in';
  Google.sendClickEvent({
    eventElement: 'global-nav-header',
    eventResult: `text-link::${destinationLabel}::${formatEvent(label)}`,
    eventNonInteractive: false
  }, option);
  Pixall.sendClickEvent({
    eventSource: 'userAccount',
    eventType: 'click',
    feature: 'global-nav-header',
    fullURL: window.location.href,
    label: `text-link_${destinationLabel}_${formatEvent(label)}`,
    pageType: 'my-at',
    pageId: DataLayerTransformer.getPageId(dataLayer),
    hasListingType: false,
    ...(isPrivateSeller && {
      pageId: 'fyc_psx_vdp'
    }),
    cdl: {
      application: {
        name: 'My Account'
      },
      eventProperties: {
        element: 'My Account Menu Navagation Link',
        elementText: label,
        location: 'My Account Menu',
        action: 'Click',
        tagIndex: 'myacct-gn-006'
      }
    }
  }, dataLayer, option);
  return rest;
}

/**
 * @summary Sends Google event when myatc sign in button clicked
 * @events event1
 */
export async function headerMyATCSignInButtonClick(metadata, option) {
  const {
    data = {}
  } = metadata;
  const {
    label,
    ...rest
  } = data;
  const eventLabel = formatEvent(label);
  Google.sendClickEvent({
    eventElement: 'global-nav-header',
    eventResult: `cta::my_sign_in::${eventLabel}`,
    eventNonInteractive: false
  }, option);
  return rest;
}

/**
 * @summary Sends Google/Pixall event when myatc sign up clicked
 * @events event1
 */
export async function headerMyATCSignUpClick(metadata, option) {
  const {
    data = {},
    dataLayer,
    state
  } = metadata;
  const {
    inventoryId,
    label,
    ...rest
  } = data;
  const inventory = getInventoryOwnerById(state, inventoryId);
  const isPrivateSeller = inventory?.owner?.privateSeller;
  const eventLabel = formatEvent(label);
  Google.sendClickEvent({
    eventElement: 'global-nav-header',
    eventResult: `cta::my_sign_up::${eventLabel}`,
    eventNonInteractive: false
  }, option);
  Pixall.sendClickEvent({
    feature: 'global-nav-header',
    eventSource: 'userAccount',
    label: `cta_${eventLabel}`,
    ...(isPrivateSeller && {
      listingType: 'pvt',
      pageId: 'fyc_psx_vdp'
    })
  }, dataLayer, option);
  return rest;
}

/**
 * @summary Sends Google/Pixall event when ico link clicked
 * @events event1
 */
export async function headerMyATCSignOutClick(metadata, option) {
  const {
    data = {},
    dataLayer,
    state
  } = metadata;
  const {
    inventoryId,
    label,
    ...rest
  } = data;
  const inventory = getInventoryOwnerById(state, inventoryId);
  const isPrivateSeller = inventory?.owner?.privateSeller;
  const eventLabel = formatEvent(label);
  Google.sendClickEvent({
    eventElement: 'global-nav-header',
    eventResult: `text-link::${eventLabel}`,
    eventNonInteractive: false
  }, option);
  Pixall.sendClickEvent({
    feature: 'global-nav-header',
    eventSource: 'userAccount',
    label: `text-link_${eventLabel}`,
    ...(isPrivateSeller && {
      listingType: 'pvt',
      pageId: 'fyc_psx_vdp'
    }),
    cdl: {
      application: {
        name: 'My Account'
      },
      eventProperties: {
        element: 'My Account Menu Sign Out Button',
        elementText: label,
        location: 'My Account Menu',
        action: 'Click',
        tagIndex: 'myacct-gn-007'
      }
    }
  }, dataLayer, option);
  return rest;
}

/**
 * @summary Sends Google and Pixall event when myWallet icon clicked
 * @events event1
 */
export async function headerMyWalletClick(metadata, option) {
  const cmp = 'my_walt';
  const {
    dataLayer
  } = metadata;
  myWalletClickHelper({
    eventResult: 'icon::open::global-nav-header'
  }, option);
  Google.sendPageDataEvent({
    dataLayer: {
      ...dataLayer,
      page: {
        siteSection: 'my-wallet',
        pageType: 'my-wallet',
        detailPageName: 'my-wallet'
      }
    }
  }, option);
  Pixall.sendClickEvent({
    feature: 'MyWallet',
    eventSource: 'userAccount',
    label: cmp,
    hasListingType: false
  }, dataLayer, option);
  return {
    cmp
  };
}

/**
 * @summary Sends Google/Pixall event when myatc sign in icon/text clicked
 * @events event1
 */
export async function headerMyATCSignInClick(metadata, option) {
  const {
    data = {},
    dataLayer,
    event,
    state
  } = metadata;
  const {
    inventoryId
  } = data;
  const inventory = getInventoryOwnerById(state, inventoryId);
  const isPrivateSeller = inventory?.owner?.privateSeller;
  const isTextLink = event.target.classList.contains('text-link');
  const eventResult = isTextLink ? 'text-link::my_sign_in::sign-in' : 'icon::my_sign_in::my-at-icon';
  const pixallLabel = isTextLink ? 'text-link::sign-in::header' : 'icon::sign-in::header';
  Google.sendClickEvent({
    eventElement: 'global-nav-header',
    eventResult,
    eventNonInteractive: false
  }, option);
  Pixall.sendClickEvent({
    feature: 'global-nav-header',
    eventSource: 'userAccount',
    label: pixallLabel,
    hasListingType: false,
    ...(isPrivateSeller && {
      listingType: 'pvt',
      pageId: 'fyc_psx_vdp'
    }),
    cdl: {
      application: {
        name: 'My Account'
      },
      eventProperties: {
        element: 'Sign In Link',
        action: 'Click',
        location: 'Global Nav Header',
        elementText: isTextLink ? 'Sign In' : null,
        elementType: isTextLink ? 'Text link' : 'Icon',
        tagIndex: 'myacct-gn-002'
      }
    }
  }, dataLayer, option);
  return metadata.data;
}

/**
 * @summary Sends Pixall event when myatc menu is closed
 * @events event 16 & 17
 */

export async function headerMyAtcMenuToggle(metadata, option) {
  const {
    data = {},
    dataLayer
  } = metadata;
  const {
    open
  } = data;
  let label = 'my-account-menu';
  let eventType = 'loaded';
  let location;
  let action = 'View';
  let tagIndex = 'myacct-gn-005';
  if (!open) {
    label = 'close-menu';
    eventType = 'click';
    location = 'Global Nav Header';
    action = 'Close';
    tagIndex = 'myacct-gn-004';
  }
  Pixall.sendClickEvent({
    feature: 'global-nav-header',
    eventSource: 'userAccount',
    label,
    eventType,
    cdl: {
      application: {
        name: 'My Account'
      },
      eventProperties: {
        element: 'My Account Menu',
        location,
        action,
        tagIndex
      }
    }
  }, dataLayer, option);
  return {};
}
export async function headerGeneralEventHandler(metadata, option) {
  const {
    data = {}
  } = metadata;
  let eventResult;
  switch (data.linkContext) {
    case 'HeaderNav':
      eventResult = headerNavItemClick(metadata, option);
      break;
    case 'CarResearchLinks':
      eventResult = headerCarResearchLinksClick(metadata, option);
      break;
    case 'PartnersTileClick':
      eventResult = headerPartnersTileClick(metadata, option);
      break;
    case 'PartnersCTAClick':
      eventResult = headerPartnersCTAClick(metadata, option);
      break;
    case 'PartnersImpression':
      eventResult = headerPartnersImpression(metadata, option);
      break;
    case 'signin':
      eventResult = headerMyATCSignInButtonClick(metadata, option);
      break;
    case 'signup':
      eventResult = headerMyATCSignUpClick(metadata, option);
      break;
    case 'signout':
      eventResult = headerMyATCSignOutClick(metadata, option);
      break;
    case 'myAtc':
      eventResult = headerSellYourCarLinksClick(metadata, option);
      break;
    case 'myWallet':
      eventResult = headerMyWalletClick(metadata, option);
      break;
    case 'myAtcSignIn':
      eventResult = headerMyATCSignInClick(metadata, option);
      break;
    case 'myAtcMenuToggle':
      eventResult = headerMyAtcMenuToggle(metadata, option);
      break;
    case 'HeaderHome':
      eventResult = headerNavItemClick({
        ...metadata,
        data: {
          onEventKey: 'home'
        }
      }, option);
      break;
    default:
      break;
  }
  return eventResult || {};
}
export default {
  headerGeneralEventHandler
};